import React from "react";

const MediaViewer = ({ response, responseFile, responsedAt, isVideo, signedUrl, REACT_APP_BUCKET_BASE_URL }) => {
  const { getExtencionImg } = require("utils");
  const { format, parseISO } = require("date-fns/esm");

  // Determinar la URL del archivo
  let mediaUrl = signedUrl;
  
  if (!mediaUrl) {
    // Fallback: construir URL manualmente
    const rawUrl = responseFile || response;
    
    if (!rawUrl) {
      return (
        <div className="flex justify-between">
          <span>{response || "Sin respuesta"}</span>
          <span>{responsedAt && format(parseISO(responsedAt), "yy/MM/dd HH:mm")}</span>
        </div>
      );
    }
    
    mediaUrl = rawUrl.startsWith('http') 
      ? rawUrl 
      : `${REACT_APP_BUCKET_BASE_URL}${rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`}`;
  }

  // Función para abrir en nueva ventana
  const handleMediaClick = () => {
    const wnd = window.open("Evidencia:blank", "", "_blank");
    const mediaElement = isVideo
      ? `<video controls style="max-width: 90vw; max-height: 90vh;" src="${mediaUrl}"></video>`
      : `<img src="${mediaUrl}" />`;
    
    let htmlString = `<html><head><title>Evidencia de G-Track</title></head><body style="display: grid; place-items: center;">${mediaElement}</body></html>`;
    wnd.document.write(htmlString);
  };

  // Renderizar video
  if (isVideo) {
    return (
      <div className="flex justify-between items-start gap-4">
        <video
          controls
          controlsList="nodownload"
          preload="metadata"
          src={mediaUrl}
          className="rounded-lg object-cover bg-black shadow-lg cursor-pointer"
          style={{ width: '360px', height: '640px' }}
          onClick={handleMediaClick}
        />
        <span className="text-sm">{format(parseISO(responsedAt), "yy/MM/dd HH:mm")}</span>
      </div>
    );
  }

  // Validar si es imagen por extensión
  const fileExtension = getExtencionImg(responseFile || response || "");
  const isImageFile = ["jpg", "png", "jpeg"].includes(fileExtension);

  // Renderizar imagen
  if (isImageFile) {
    return (
      <div className="flex justify-between">
        <img
          src={mediaUrl}
          className="border rounded-lg h-[80px] w-[100px] cursor-pointer"
          alt="Evidencia"
          onClick={handleMediaClick}
        />
        <span>{format(parseISO(responsedAt), "yy/MM/dd HH:mm")}</span>
      </div>
    );
  }

  // Si no es imagen ni video, mostrar como texto
  return (
    <div className="flex justify-between">
      <span>{response}</span>
      <span>{format(parseISO(responsedAt), "yy/MM/dd HH:mm")}</span>
    </div>
  );
};

export default MediaViewer;
